<template>
  <div class="aboutPc">
    <!-- 公司介绍 -->
    <div class="company-box">
      <div class="container company">
        <!-- <div class="title">优加是谁</div> -->
        <div class="company_con">
          <div class="right">
            <div class="company_con_txt" v-html="aboutTxt">
              <!-- <p>
                优加健保健康科技（北京）有限公司是一家智能链接保险、医疗、企业及行业用户的数字化管理式医疗健康服务组织，提供“医-护-健-药-械-险”的一站式健康管理及保险产品定制开发服务，涵盖医疗+健康+保障的全流程定制解决方案。
              </p>
              <p>优加健康以“让每个家庭拥有自己的医护朋友”为使命，致力于成为“中国领先的数字化管理式医疗健康服务组织”，已在全国开设分公司数10家。</p>
              <p>
                优加健康通过智能化SAAS平台“优医链”链接线下医疗网络机构超过10万家；通过数字化O2O工具平台“优服帮”链接3万余名商保护士和2万余名商保医生，覆盖400+个城市，提供7*24小时线上+线下的闭环服务；通过智能客户端SAAS平台“优企服”服务和链接超270家大中保司和平台型企业，付费终端用户数超过7600万，累计服务人数超过660万，累计服务人次超过2000万。
              </p> -->
            </div>
          </div>
          <img src="https://cdn.youjiajk.com/companyInfoImg1.png" alt="" width="551" height="463">
        </div>
      </div>
    </div>
    <!-- 公司文化 -->
    <div class="company-culture">
      <div class="container">
        <div class="cultureCon">
          <div class="item">
            <div class="itemPosition">
              <img class="icon" src="../../assets/image/icon1.png" />
              <p class="itemTitle">使命</p>
              <p class="itemTxt">让每个家庭拥有自己的医护朋友</p>
            </div>
            <img class="num" src="../../assets/image/01Icon.png" />

          </div>
          <div class="item">
            <div class="itemPosition">
              <img class="icon" src="../../assets/image/icon1.png" />
              <p class="itemTitle">愿景</p>
              <p class="itemTxt">中国领先的数字化管理式医疗健康服务组织</p>
            </div>
            <img class="num" src="../../assets/image/02Icon.png" />
          </div>
          <div class="item">
            <div class="itemPosition">
              <img class="icon" src="../../assets/image/icon1.png" />
              <p class="itemTitle">价值观</p>
              <p class="itemTxt">用户至上 合作共赢 专业价值 追求卓越</p>
            </div>
            <img class="num" src="../../assets/image/03Icon.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 融资历程 -->
    <div class="financing">
      <div class="container">
        <div class="financingCon">
          <div class="title" style="color: #333333;">融资历程</div>
          <img src="https://cdn.youjiajk.com/aboutFinancing1.png" alt="" width="1200">
          <div class="con">
            <div class="conItem">
              <h4>2017/06</h4>
              <p>获得联想之星天使轮投资</p>
            </div>
            <div class="conItem">
              <p>获得愉悦资本投资管理有限公司 <br /> 数百万美元A轮投资</p>
              <h4>2018/11</h4>
            </div>
            <div class="conItem">
              <h4>2020/07</h4>
              <p>获得东方弘泰资本、品驰医疗的 <br /> 数千万人民币A+轮投资</p>
            </div>
            <div class="conItem">
              <p>完成康裕资本、联想之星等知名基金<br />合投的亿元B轮融资</p>
              <h4>2022/04</h4>
            </div>
            <div class="conItem">
              <h4>2022/09</h4>
              <p>获得美鸿大健康产业基金<br>战略投资</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'
export default {
  components: {
    swiper,
    swiperSlide
  },
  props: {
    newsList: {
      type: Array,
      default: []
    },
    teamList: {
      type: Array,
      default: []
    },
    aboutTxt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      navItemList: ['公司介绍', '精英团队', '公司荣誉', '联系我们'],

      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOption2: {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 3,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination1',
          clickable: true
        }
      },
      honorList: [{
        text: '2021中国保险科技100强-<b>分子实验室</b>'
      }, {
        text: '2021最佳健康险智能服务平台提供商-<b>2021健康医疗产业保险峰会</b>'
      }, {
        text: '优加健康创始人＆CEO王艳萍女士荣获创业邦<b>2021年30位最值得关注的创业女神女性创业者</b>'
      }, {
        text: '荣获人保健康2020年度<b>《优秀健康管理服务合作伙伴》</b>'
      }, {
        text: '荣获创业邦<b>“2020中国医疗大健康创新企业80强”</b>'
      }, {
        text: '2020 · 亚洲健康险决策者论坛的<b>《年度最佳互联网健康险保险服务平台》</b>奖'
      }, {
        text: '2019 ･ 爱分析<b>中国保险科技创新企业30强</b>'
      }, {
        text: '“InsurStar2019-<b>中国保险科技50强</b>”—2019保险科技引领者'
      }, {
        text: '动脉网“2019未来医疗100强 ･ 中国榜<b>健康险TPA TOP10</b>'
      }, {
        text: '动脉网“2018未来医疗100强” 评选<b>“保险支付”</b>模块<b>第二名</b>'
      }],

      reRender: false
    }
  },
  created () {
    setTimeout(() => {
      this.reRender = true
    }, 100)
  },
  methods: {
    addActive ($event) {
      $event.currentTarget.className = 'navItem actived'
    },
    removeActive ($event) {
      $event.currentTarget.className = 'navItem'
    },
    goToAnchor (index) {
      this.$el.querySelector(`#text${index}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start" // 上边框与视窗顶部平齐
      });
    },
    newsGoPage (href) {
      console.log(href)
      window.open(href, '_blank');
    }
  }
}
</script>

<style lang="less" scoped>
.backgroundGray {
  background: #F7FAFF;
}

.container {
  width: 1200px;
  margin: 0 auto;
}

.aboutPc {
  font-size: 14px;
  display: flex;
  flex-direction: column;


  .company-box {
    background: #FFFFFF;
    padding: 140px 0;

    .company {
      .company_con {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        margin-top: 42px;
      }

      .right {
        width: 479px;
        margin-right: 37px;

        .rightTitle {
          font-size: 18px;
          font-weight: 600;
          text-align: left;
          margin-bottom: 10px;
        }

        .company_con_txt {
          font-weight: 300;
          line-height: 26px;
          margin-top: 42px;
          text-align: left;
          font-size: 16px;
          color: #666666;

          p {
            margin-bottom: 20px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }


  .company-culture {
    background: #F8F9FD;

    .cultureCon {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 140px 0;

      .item {
        width: 33%;
        position: relative;

        &:nth-child(1) {
          width: 30%;
        }

        &:nth-child(2) {
          width: 36%;
        }

        .itemPosition {
          position: relative;
          z-index: 20;

          .icon {
            width: 36px;
            height: 54px;
          }

          .itemTitle {
            font-size: 26px;
            color: #333333;
            line-height: 39px;
            font-weight: 500;
          }

          .itemTxt {
            margin-top: 20px;
            font-size: 18px;
            font-weight: 300;
            color: #333333;
          }
        }

        .num {
          position: absolute;
          width: 134px;
          height: 182px;
          right: 44px;
          bottom: -5px;

          &:nth-child(1) {
            right: 42px;
          }

          &:nth-child(2) {
            right: 57px;
          }

          &:nth-child(3) {
            right: 65px;
          }
        }
      }
    }
  }

  .financing {
    background-image: url("../../assets/image/aboutBanner1.png");
    width: 100%;
    // height: 712px;
    background-size: 100% 100%;

    .financingCon {
      padding: 140px 0 178px;
      color: #666666;

      .con {
        position: relative;

        .conItem {
          position: absolute;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          h4 {
            font-size: 20px;
            color: #333333;
            line-height: 30px;
            font-weight: 500;
            margin: 0;
            margin-bottom: 9px;
          }

          p {
            text-align: center;
            line-height: 26px;
          }

          &:nth-child(1) {
            left: -39px;
            bottom: -40px;
          }

          &:nth-child(2) {
            left: 134px;
            top: -172px;

            h4 {
              margin-top: 9px;
            }
          }

          &:nth-child(3) {
            left: 462px;
            bottom: 26px;
          }

          &:nth-child(4) {
            right: 260px;
            bottom: 169px;

            h4 {
              margin-top: 9px;
            }
          }

          &:nth-child(5) {
            right: -75px;
            bottom: 185px;
          }
        }
      }
    }
  }

  .title {
    width: 100%;
    text-align: center;
    font-size: 40px;
    font-weight: 400;
    margin-bottom: 60px;

    .subTitle {
      color: #FFFFFF;
      opacity: 0.5;
      font-size: 14px;
      font-weight: 300;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/pc/aboutPc.vue